import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e083457"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "upgradeModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "upgradeModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title text-white" }, "Upgrade Subscription", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close btn-close-white",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "text-dark text-center"
}
const _hoisted_10 = {
  key: 1,
  class: "text-dark text-center text-success mt-3 mb-3"
}
const _hoisted_11 = {
  key: 2,
  class: "text-dark text-success mt-3 mb-3"
}
const _hoisted_12 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.done && !_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Are you sure you want to upgrade to \"" + _toDisplayString(_ctx.selectedPlan?.name) + "\"?", 1))
              : _createCommentVNode("", true),
            (_ctx.done)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, "You have successfully upgraded your plan."))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("pre", _hoisted_11, "An error occured: " + _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (!_ctx.done && !_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success ms-2",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeSubscription && _ctx.changeSubscription(...args))),
                disabled: _ctx.submitted
              }, _toDisplayString(_ctx.submitted ? "Upgrading..." : "Upgrade"), 9, _hoisted_13)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}